module.exports = __webpack_public_path__ + "img/50mov.bcdac832.jpg";